export default __webpack_public_path__ + "static/media/frame_corner_bottom_right.f6933195.png";